import React from "react"
import styled from 'styled-components'
import HamburgerMenu from 'react-hamburger-menu'

class MobileNav extends React.Component { 
    state = {
        open: false,
    }

    handleClick = () => {
        const { open } = this.state;
        this.setState({ open: !open });
        this.props.toggleMenu();
    }

    render() {
        return (
            <Container>
                <Wrap>
                <HamburgerMenu
                    isOpen={this.state.open}
                    menuClicked={this.handleClick}
                    width={28}
                    height={15}
                    strokeWidth={3}
                    rotate={0}
                    color='black'
                    borderRadius={0}
                    animationDuration={0.2}
                />
                </Wrap>
                
            </Container>
            
        )
    }
}

const Container = styled.div`
    text-align: right;
    padding: 0 2rem;
  @media (min-width: 1160px) {
    display: none;
  }
`;

const Wrap = styled.div`
    display: flex;
    justify-content: right;
`;


export default MobileNav